import fetchWiremock from 'utilities/mock/fetchWiremock';
import { BasketAddItemOptions, BasketResponse, NormalisedBasketResponse } from 'types/BasketTypes';
import { BasketServiceInterface } from '../interface/BasketServiceInterface';

export default class MockBasketService implements BasketServiceInterface {
  async addItem({ item }: BasketAddItemOptions): Promise<NormalisedBasketResponse> {
    const response = await fetchWiremock({
      method: 'POST',
      path: '/api/checkout/v1/basket/items',
      body: item,
    });

    const data = (await response.json()) as BasketResponse;

    return {
      success: response.ok,
      status: response.status,
      statusText: response.statusText,
      ...data,
    };
  }
}
